var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.666504C15.1826 0.666504 18.2348 1.93079 20.4853 4.18122C22.7357 6.43166 24 9.48391 24 12.6665C24 16.7652 21.7653 20.1198 19.4107 22.5265C18.234 23.7157 16.9504 24.794 15.576 25.7478L15.008 26.1345L14.7413 26.3118L14.2387 26.6318L13.7907 26.9052L13.236 27.2278C12.8593 27.4422 12.4334 27.555 12 27.555C11.5666 27.555 11.1407 27.4422 10.764 27.2278L10.2093 26.9052L9.516 26.4785L9.26 26.3118L8.71333 25.9478C7.23064 24.9443 5.84942 23.7984 4.58933 22.5265C2.23467 20.1185 0 16.7652 0 12.6665C0 9.48391 1.26428 6.43166 3.51472 4.18122C5.76515 1.93079 8.8174 0.666504 12 0.666504ZM12 8.6665C11.4747 8.6665 10.9546 8.76997 10.4693 8.97099C9.98396 9.172 9.54301 9.46664 9.17157 9.83808C8.80014 10.2095 8.5055 10.6505 8.30448 11.1358C8.10346 11.6211 8 12.1412 8 12.6665C8 13.1918 8.10346 13.7119 8.30448 14.1972C8.5055 14.6825 8.80014 15.1235 9.17157 15.4949C9.54301 15.8664 9.98396 16.161 10.4693 16.362C10.9546 16.563 11.4747 16.6665 12 16.6665C13.0609 16.6665 14.0783 16.2451 14.8284 15.4949C15.5786 14.7448 16 13.7274 16 12.6665C16 11.6056 15.5786 10.5882 14.8284 9.83808C14.0783 9.08793 13.0609 8.6665 12 8.6665Z",
    fill: "#101016"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainMarker);
export default __webpack_public_path__ + "static/media/main-marker.1d6a461b3e0cb6586b2f98fc59e77511.svg";
export { ForwardRef as ReactComponent };